module.exports = __webpack_public_path__ + "img/TSN_03.0feab353.png";